/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fw_Faq_A6Inputs */

const en_fw_faq_a6 = /** @type {(inputs: Fw_Faq_A6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. This is an unofficial fan site that gathers public information and links to official sources. The official anime site is hotaru-anime.com.`)
};

const zh_fw_faq_a6 = /** @type {(inputs: Fw_Faq_A6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`不是。本站是非官方粉丝站，只整理公开资讯并链接到官方来源。动画官方网站为 hotaru-anime.com。`)
};

/**
* | output |
* | --- |
* | "No. This is an unofficial fan site that gathers public information and links to official sources. The official anime site is hotaru-anime.com." |
*
* @param {Fw_Faq_A6Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const fw_faq_a6 = /** @type {((inputs?: Fw_Faq_A6Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fw_Faq_A6Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_fw_faq_a6(inputs)
	return zh_fw_faq_a6(inputs)
});
export { fw_faq_a6 as "fw.faq.a6" }